<div class="modal-header">
  <h5 class="modal-title">Reschedule Item</h5>

  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="modal.dismiss()"
  ></button>
</div>

<div class="modal-body">
  <form [formGroup]="form">
    <div class="schedule-modal-summary">
      <div class="summary-item">
        <span>Schedule ID</span>
        <strong>{{ row.scheduleId }}</strong>
      </div>

      <div class="summary-item">
        <span>Source / Job ID</span>
        <strong>{{ row.source }}</strong>
      </div>

      <div class="summary-item">
        <span>Project Name</span>
        <strong>{{ row.projectName }}</strong>
      </div>

      <div class="summary-item">
        <span>Item Category</span>
        <strong>{{ row.itemCategory }}</strong>
      </div>

      <div class="summary-item">
        <span>Item ID</span>
        <strong>{{ row.itemId }}</strong>
      </div>

      <div class="summary-item">
        <span>Status</span>
        <strong>{{ row.status }}</strong>
      </div>
    </div>

    <div class="mb-2">
      <label for="SCHEDULE_ITEM_DATE">Date</label>

      <div class="input-group input-group-sm">
        <input
          id="SCHEDULE_ITEM_DATE"
          class="form-control form-control-sm"
          placeholder="YYYY-MM-DD"
          ngbDatepicker
          #scheduleDatePicker="ngbDatepicker"
          container="body"
          [minDate]="today"
          formControlName="date"
          required
          [class.is-invalid]="
            date.invalid && (date.dirty || date.touched)
          "
        />

        <button
          type="button"
          class="btn btn-outline-primary btn-sm"
          (click)="scheduleDatePicker.toggle()"
        >
          <fa-icon [icon]="faCalendarDays"></fa-icon>
        </button>
      </div>

      <div *ngIf="date.invalid && (date.dirty || date.touched)">
        <div
          *ngIf="date.errors?.['required']"
          class="input-validation-msg"
        >
          Date is required.
        </div>
      </div>
    </div>

    <div class="mb-2">
      <label for="SCHEDULE_ITEM_TIME">Time</label>

      <div class="input-group input-group-sm">
        <input
          id="SCHEDULE_ITEM_TIME"
          type="time"
          class="form-control form-control-sm"
          step="60"
          formControlName="time"
          required
          [class.is-invalid]="
            time.invalid && (time.dirty || time.touched)
          "
        />

        <span class="input-group-text">
          <fa-icon [icon]="faClock"></fa-icon>
        </span>
      </div>

      <div *ngIf="time.invalid && (time.dirty || time.touched)">
        <div
          *ngIf="time.errors?.['required']"
          class="input-validation-msg"
        >
          Time is required.
        </div>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button
    type="button"
    class="btn btn-outline-secondary"
    (click)="modal.dismiss()"
  >
    Cancel
  </button>

  <button
    type="button"
    class="btn btn-primary"
    [disabled]="form.invalid"
    (click)="updateSchedule()"
  >
    Update Schedule
  </button>
</div>